import {
  AvailableToWithdrawInCentsQuery,
  AvailableToWithdrawInCentsQueryVariables,
  UseAvailableToWithdrawProps,
} from "@ctypes";
import { AVAILABLE_TO_WITHDRAW_IN_CENTS } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const useAvailableToWithdraw = ({ goalId, subaccountId }: UseAvailableToWithdrawProps) => {
  const { data: queryData, ...rest } = useQuery<
    AvailableToWithdrawInCentsQuery,
    AvailableToWithdrawInCentsQueryVariables
  >(AVAILABLE_TO_WITHDRAW_IN_CENTS, {
    variables: {
      goalId,
      subaccountId,
    },
  });

  const data = queryData?.availableToWithdrawInCents;

  return { data, ...rest };
};
